import React from "react";
import PropTypes from "prop-types";
import TrafficLights from "../TrafficLights";

const Timeslot = ({
    isFirst,
    isFirstContent,
    time,
    availability,
    defaultValue,
    onValueChange,
    append,
}) => {
    let status;

    if (availability) {
        switch (availability) {
            case "ok":
                status = 3;
                break;
            case "warning":
                status = 2;
                break;
            case "critical":
                status = 1;
                break;
            default:
                status = 0;
                break;
        }
    }

    const timeSlotStyles = isFirst
        ? "timeslot__content isFirst"
        : "timeslot__content";

    const checked = defaultValue ? time.begin === defaultValue.begin : false;

    return (
        <label className="timeslot">
            <input
                name="timeslot"
                type="radio"
                value={time.begin}
                disabled={status === 0}
                onChange={onValueChange}
                checked={checked}
            />
            <div className={timeSlotStyles}>
                <div className="timeslot__text">
                    <span className="timeslot__time">
                        {append ? `${append}, ${time.timeSlot}` : time.timeSlot}
                    </span>
                    {isFirst && <p>{isFirstContent}</p>}
                </div>
                {availability && <TrafficLights status={status} />}
            </div>
        </label>
    );
};

Timeslot.propTypes = {
    isFirst: PropTypes.bool,
    isFirstContent: PropTypes.string,
    defaultValue: PropTypes.object,
    time: PropTypes.object.isRequired,
    append: PropTypes.string,
    availability: PropTypes.string,
    onValueChange: PropTypes.func,
};

export default Timeslot;
